<template>
  <div class="section-statistics__percentage-cards">
    <CmPercentageCard
      v-for="(item, index) in value"
      :key="index"
      :data="item"
    />
  </div>
</template>

<script>
import CmPercentageCard from "@/components/library/statistics/cards/CmPercentage.vue";

export default {
  components: {
    CmPercentageCard
  },

  props: {
    value: {
      type: Object
    }
  }
}
</script>
